import type { Activity } from '@/app/types';

/** Which link a stop shows (JAR-2450): its place's own website, or its page on a
 *  booking site or the Explore provider it was added from. Null when it has none.
 *  StopLink draws it and the Trip Plan's legend lists it, so the two agree (JAR-2698). */
export const stopLinkKind = (stop: Pick<Activity, 'providerUrl' | 'linkKind'>): 'website' | 'provider' | null =>
  !stop.providerUrl ? null : stop.linkKind === 'website' ? 'website' : 'provider';
